export default __webpack_public_path__ + "static/media/tech-advisor.795a8369.png";